import classNames from 'classnames';
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { branch, compose, lifecycle, renderNothing, withStateHandlers } from 'recompose';
import { persistStore } from 'redux-persist';
import createFilter from 'redux-persist-transform-filter';
import { routes } from './constants';
import { AdminPortal, App, Onboarding, PublisherPortal } from './containers/layouts';
import { Authenticate, ForgotPassword, HealthCheck, LoggedOut, Login, Logout, Referral, ResetPassword } from './containers/pages';
import { Footer } from './containers/partials';
import logo from './images/logo.png';

const withFooter = (className) => (Component) => (props) => (
  <div className={classNames('clearfix', className)}>
    <Component {...props} />
    <Footer logo={logo} />
  </div>
);

const Routes = () => (
  <Switch>
    {/* Healthcheck routes*/}
    <Route path={routes.app.healthCheck} component={HealthCheck} />

    {/* On boarding routes */}
    <Route path={routes.onboarding.root} component={withFooter('onboarding')(Onboarding)} />

    {/* Login routes */}
    <Route path={routes.login} component={withFooter()(Login)} />
    <Route path={routes.logout} component={withFooter()(Logout)} />
    <Route path={routes.loggedOut} component={withFooter()(LoggedOut)} />
    <Route path={routes.referral} component={withFooter()(Referral)} />
    <Route path={routes.authenticate} component={withFooter()(Authenticate)} />
    <Route path={routes.forgotPassword} component={withFooter()(ForgotPassword)} />
    <Route path={routes.resetPassword} component={withFooter()(ResetPassword)} />

    {/* Publisher portal routes */}
    <Route path={routes.publisherPortal.root} component={withFooter('for-publishers')(PublisherPortal)} />

    {/* Admin portal routes */}
    <Route path={routes.adminPortal.root} component={withFooter('for-admins')(AdminPortal)} />

    {/* Main application routes */}
    <Route path={routes.app.root} component={App} />
  </Switch>
)

// Note that Routes cannot use the higher order component connect
export default compose(
  withRouter,
  withStateHandlers({
    rehydrated: false
  }, {
      onPersistStore: () => () => ({
        rehydrated: true
      })
    }),
  lifecycle({
    componentWillMount() {
      const store = require('./state/store');

      const persistConfig = {
        // We only persist the session to avoid problems when new versions of Caddie change the shape of the state.
        whitelist: ['session', 'global'],
        transforms: [
          // And we further persist only the bare minimum to allow users to remain logged in.
          createFilter('session', ['userId', 'idToken', 'mockUserId', 'isAuthenticated'])
        ]
      };

      // Emit store hydrated state change to make sure the store's
      // values have been loaded successfully.
      persistStore(store.default, persistConfig, this.props.onPersistStore);
    }
  }),
  branch(
    ({ rehydrated }) => !rehydrated,
    renderNothing
  )
)(Routes);



// WEBPACK FOOTER //
// ./src/routes.js